import React, { ChangeEvent, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { InputGroup } from 'reactstrap';
import { compose } from 'recompose';
import TextInput from '../../components/TextInput';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import chatbotCRUDActions from '@mm/state/actions/ChatbotCRUDActions';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import {
  CONFIRM_MODAL_DESCRIPTION,
  CONFIRM_MODAL_INSTRUCTION,
} from './constants';
import './ConfirmDeleteChatbotModal.scss';
import { StoreState } from '@mm/state/store-interfaces';
import { Dispatch } from 'redux';
import ChatbotModel from '@mm/state/model/ChatbotModel';
import { ModalInstanceProps } from '../interfaces';
import {
  activeChatbotIdSelector,
  activeFacebookPageIdSelector,
} from '@mm/state/selectors/viewSelectors';
import { withRouter } from 'react-router';
import { RouterComponentProps } from '../../helpers/routes/interfaces';
import { CHATBOT_EDITOR } from '../../constants/routes';

type OuterProps = {
  bot: ChatbotModel;
  companyId: number;
};

type InnerProps = RouterComponentProps &
  ModalInstanceProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

const ConfirmDeleteChatbotModal = (props: Props) => {
  const {
    deleteChatbot,
    closeModal,
    bot,
    activeFacebookPageId,
    activeChatbotId,
    history,
  } = props;
  const [confirmationWord, setConfirmationWord] = useState('');
  const deleteDisabled = confirmationWord.toLowerCase() !== 'delete';

  const onChangeConfirmWord = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setConfirmationWord(e.target.value);
  };

  const onDelete = useCallback(() => {
    deleteChatbot(bot.id, activeFacebookPageId);

    if (activeChatbotId === bot.id) {
      history.push(CHATBOT_EDITOR);
    }

    closeModal();
  }, [bot.id, activeFacebookPageId]);

  return (
    <div>
      <ModalHeader className="confirm-delete-chatbot-modal__header">
        <h3>Are you sure you want to delete {bot.name}?</h3>
      </ModalHeader>
      <ModalBody>
        <h5 className="confirm-delete-chatbot-modal__description">
          {CONFIRM_MODAL_DESCRIPTION}
        </h5>
        <h5 className="confirm-delete-chatbot-modal__description">
          {CONFIRM_MODAL_INSTRUCTION}
        </h5>
        <InputGroup className="mb-3 confirm-delete-chatbot-modal__input-group">
          <TextInput
            value={confirmationWord}
            onChange={onChangeConfirmWord}
            className="confirm-delete-chatbot-modal__text-input"
          />
        </InputGroup>
      </ModalBody>
      <ModalFooter>
        <Button onClick={closeModal}>Cancel</Button>
        <Button red onClick={onDelete} disabled={deleteDisabled}>
          Delete
        </Button>
      </ModalFooter>
    </div>
  );
};

const mapStateToProps = (state: StoreState) => ({
  confirmDeleteChatbot: state.view.confirmDeleteChatbot,
  activeFacebookPageId: activeFacebookPageIdSelector(state),
  activeChatbotId: activeChatbotIdSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  deleteChatbot: (botId: number, facebookPageId: number) =>
    dispatch(chatbotCRUDActions.delete(botId, facebookPageId)),
});

const enhance = compose<InnerProps, OuterProps>(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(ConfirmDeleteChatbotModal);
